import * as Address from "./Address";
export interface IVerifiedAddress extends Address.IAddress {
  latitude: number;
  longitude: number;
  zip4: string;
}

export class VerifiedAddress extends Address.AddressInitialized
  implements IVerifiedAddress {
  latitude = 0;
  longitude = 0;
  zip4: string;
}
